import { createRegexFromArray } from "../../utilities/create-regex-from-array";
import { SalesFilterValues } from "./types";

export const defaultSaleFilterValues: SalesFilterValues = {
  locationId: [],
  saleType: [],
  productId: [],
  customerId: [],
  terminalId: [],
  isAcceptedQuote: false,
  isReturn: false,
  source: [],
};

export const saleFilterValuesToApiInput = (filterValues: SalesFilterValues) => {
  let v = {};

  if (filterValues.isAcceptedQuote) {
    v = {
      ...v,
      quoteAccepted: {
        eq: true,
      },
    };
  }

  if (filterValues.isReturn) {
    v = {
      ...v,
      returnForId: {
        isNull: false,
      },
    };
  }

  if (filterValues.terminalId?.length) {
    v = {
      ...v,
      terminalId: {
        in: filterValues.terminalId,
      },
    };
  }

  if (filterValues.customerId?.length) {
    v = {
      ...v,
      customerId: {
        in: filterValues.customerId,
      },
    };
  }

  if (filterValues.productId?.length) {
    v = {
      ...v,
      productId: {
        in: filterValues.productId,
      },
    };
  }

  if (filterValues.locationId?.length) {
    v = {
      ...v,
      locationId: {
        in: filterValues.locationId,
      },
    };
  }

  if (filterValues.source?.length) {
    v = {
      ...v,
      source: {
        in: filterValues.source,
      },
    };
  }

  if (filterValues.saleType?.length) {
    /**
     *
     * The state machine for "sales" does not include a prefix of
     * "SALE_" where as the other states do. This is a special case
     *
     */
    const includesSale = filterValues.saleType.includes("SALE");
    const withoutSale = filterValues.saleType.filter((v) => v !== "SALE");
    v = {
      ...v,
      state: {
        regex: createRegexFromArray(
          withoutSale,
          includesSale
            ? ["SAVED", "CLOSED", "CANCELLED", "VOIDED", "CREATED"]
            : undefined
        ),
      },
    };
  }

  return v;
};
